import React, { useEffect } from 'react';
import AuthService from '../../vendors/services/authService';
import DefaultPage from './DefaultPage';
import PublicPage from './PublicPage';
import store from '../../vendors/redux/store';
import AuthActionTypes from '../../vendors/redux/auth/authActionTypes';
import { InformesEventoProvider } from '../shared/contexts/InformesEventoContext';

export default function Page() {
  const authService = new AuthService();
  const auth = authService.getCurrentState();

  useEffect(() => {
      const user = AuthService.getUser();
      if (user && !auth?.user) {
          store.dispatch({ type: AuthActionTypes.SAVE, user });
      }
  }, [auth?.user]);

  return (
    <InformesEventoProvider>
      {auth && auth.user ? <DefaultPage /> : <PublicPage />}
    </InformesEventoProvider>
  );
};
